<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">USER CONFIGURATION</h1>
			<button type="button" class="btn btn-bertazzoni black rounded-0 mt-3" routerLink="0">NEW USER</button>
		</div>
		<div class="row">
			<div class="col-12">
				<!--LASCIARE ORDINAMENTO SOLO SU COLONNA CLIENTE AS400, LE SELECT DELLE ALTRE DUE COLONNE PARTONO DISABILITATE E IL BTN SALVA NASCOSTO. SI ATTIVA TUTTO AL CLICK SULLA MODIFICA-->
				<table datatable [dtTrigger]="dtTrigger" class="row-border hover">
					<thead>
						<tr>
							<th>Username</th>
							<th>Email</th>
							<th>Role</th>
							<th>Client</th>
							<th>Company</th>
							<th>LT Active</th>
							<th>Markets (Partner)</th>
							<!-- <th>Agente</th> -->
							<th></th>
						</tr>
					</thead>
					<tbody *ngIf="utenti.length > 0">
						<tr *ngFor="let utente of utenti">
							<td>{{utente.username}}</td>
							<td>{{utente.email}}</td>
							<td>{{utente.ruolo}}</td>
							<td>{{utente.cliente?.ragioneSociale}}</td>
							<td>{{utente.company.descrizione}}</td>
							<td class="text-center">{{utente.leadTimeAttivo ? '&#10003;' : '&#10007;' }}</td>
							<td>{{utente.mercati}}</td>
							<!-- <td>{{utente.agente ? utente.agente.username : '/'}}</td> -->
							<th>
								<img src="assets/img/pencil.svg" class="action-icon" [routerLink]="utente.id" />
							</th>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
